import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=91587d48&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=91587d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91587d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91587d48')) {
      api.createRecord('91587d48', component.options)
    } else {
      api.reload('91587d48', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=91587d48&scoped=true&", function () {
      api.rerender('91587d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/Loading.vue"
export default component.exports